module.exports = __webpack_public_path__ + "img/signature.587fc719.png";